class ResponseError extends Error {
    constructor(response) {
        super(`${response.status || response.statusCode} "${response.statusText}"`);

        this.raw = response;
        this.statusCode = response.status || response.statusCode;
        this.statusText = response.statusText;
    }
}

class LoginError extends Error {
    constructor(response) {
        super(`${response.errorCode} "${response.errorMessage}"`);

        this.raw = response;
        this.errorCode = response.errorCode;
        this.errorMessage = response.errorMessage;
        this.errorDetails = response.errorDetails;
    }
}

class LogoutError extends Error {
    constructor(response) {
        super(`${response.errorCode} "${response.errorMessage}"`);

        this.raw = response;
        this.errorCode = response.errorCode;
        this.errorMessage = response.errorMessage;
        this.errorDetails = response.errorDetails;
    }
}

export {ResponseError, LoginError, LogoutError};
